<template lang="pug">
  button.button.button--icon(
    type="button",
    :class="buttonClass",
    :disabled="isDisabled",
    @click="$emit('click')"
  )
    icon(v-if="icon", :name="icon", :height="getHeight" :width="getWidth")
    span.u-sr-only {{ label }}
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue'
  import PrimaryButton from 'scripts/components/buttons/PrimaryButton.vue'

  export default {
    extends: PrimaryButton,
    components: { Icon },
    name: 'IconButton',
    props: {
      height: String,
      width: String,
      size: {
        type: String,
        default: '24px'
      }
    },
    computed: {
      getWidth() {
        return this.width ? this.width : this.size;
      },
      getHeight() {
        return this.height ? this.height : this.size;
      },
    },
  }
</script>

<style scoped lang="scss">
</style>
